import React, { useState, useRef } from "react";
import styles from "./FAQ.module.scss"; // Updated to use SCSS module

import gsap from "gsap";
import { useGSAP } from "@gsap/react";



const questionsAndAnswers = [
  {
    question: "Where does cork come from?",
    answer: (
      <>
        <p>
          Cork is harvested from the bark of the cork oak tree (Quercus suber),
          which is native to the Mediterranean region. The primary countries
          where cork oak forests are found and where most cork is harvested
          include:
        </p>
        <p>
          <div className={styles.noahBold}>Portugal:</div> The largest producer
          of cork, accounting for about 50% of the world's production.
        </p>
        <p>
          <div className={styles.noahBold}>Spain:</div> Another major producer,
          contributing significantly to the global cork supply.
        </p>
        <p>
          <div className={styles.noahBold}>Italy:</div> Particularly in regions
          like Sardinia.
        </p>
        <p>
          <div className={styles.noahBold}>France:</div> Notably in the Provence
          and Corsica regions.
        </p>
        <p>
          <div className={styles.noahBold}>Morocco:</div> Also a significant
          contributor to the cork industry.
        </p>
        <p>
          <div className={styles.noahBold}>Tunisia:</div> Along with other North
          African countries, it has cork oak forests.
        </p>
      </>
    ),
  },
  {
    question: "What are the advantages of cork?",
    answer: (
      <>
        <p>
          Cork offers a variety of benefits due to its unique properties and
          sustainable nature. Here are some of the key advantages:
        </p>
        <p>
          <div className={styles.noahBold}>Sustainability:</div> Cork is
          harvested from the bark of cork oak trees without harming the tree,
          allowing it to regenerate and be harvested again every 9 to 12 years.
        </p>
        <p>
          <div className={styles.noahBold}>Eco-Friendly:</div> The cork industry
          promotes forest conservation and biodiversity. Cork oak forests play a
          critical role in carbon sequestration, soil erosion prevention, and
          water cycle regulation.
        </p>
        <p>
          <div className={styles.noahBold}>Low Density:</div> Cork is extremely
          lightweight, making it easy to handle and transport.
        </p>
        <p>
          <div className={styles.noahBold}>Buoyancy:</div> Its buoyant nature
          makes cork ideal for products like fishing floats and life jackets.
        </p>
        <p>
          <div className={styles.noahBold}>Thermal Insulation:</div> Cork has
          excellent thermal insulation properties, making it useful in
          construction for energy-efficient buildings.
        </p>
        <p>
          <div className={styles.noahBold}>Acoustic Insulation:</div> It also
          provides good sound insulation, reducing noise transmission in
          buildings and other applications.
        </p>
        <p>
          <div className={styles.noahBold}>Flexible:</div> Cork can be
          compressed and then return to its original shape, making it suitable
          for gaskets, seals, and bottle stoppers.
        </p>
        <p>
          <div className={styles.noahBold}>Shock Absorption:</div> Its ability
          to absorb shocks makes it an excellent material for flooring,
          footwear, and protective packaging.
        </p>
        <p>
          <div className={styles.noahBold}>Durability:</div>
        </p>
        <p>
          <div className={styles.noahBold}>Resistant to Wear:</div> Cork is
          durable and resistant to wear and tear, which contributes to its
          longevity in various applications.
        </p>
        <p>
          <div className={styles.noahBold}>Resistant to Moisture:</div> While it
          is impermeable to liquids, cork remains resistant to moisture and
          mold, enhancing its durability.
        </p>
        <p>
          <div className={styles.noahBold}>
            Hypoallergenic and Biodegradable:
          </div>
        </p>
        <p>
          <div className={styles.noahBold}>Non-Toxic:</div> Cork is
          hypoallergenic, free from harmful chemicals, and safe for use in
          various products, including those that come in contact with food and
          skin.
        </p>
        <p>
          <div className={styles.noahBold}>Biodegradable:</div> Cork is a
          natural material that decomposes without releasing toxins, making it
          environmentally friendly.
        </p>
        <p>
          <div className={styles.noahBold}>Aesthetic and Versatile:</div>
        </p>
        <p>
          <div className={styles.noahBold}>Natural Appearance:</div> Cork has a
          unique, natural aesthetic that adds a warm and organic look to
          products and interiors.
        </p>
        <p>
          <div className={styles.noahBold}>Versatility:</div> It can be used in
          a wide range of products, including flooring, wall coverings,
          furniture, fashion accessories, and even in the aerospace industry.
        </p>
      </>
    ),
  },
  {
    question: "How to clean Cork Matters products?",
    answer: (
      <>
        <p>
          Cork products must be cleaned carefully to preserve their properties
          and ensure their durability.
        </p>
        <p>
          <div className={styles.noahBold}>Regular Cleaning</div>
        </p>
        <p>
          Light Dust and Dirt: Use a soft, dry cloth or a soft-bristled brush to
          remove dust and light dirt from the surface.
        </p>
        <p>
          <div className={styles.noahBold}>Heavier Stains and Dirt:</div>
        </p>
        <p>
          Prepare a solution of warm water and mild soap. Dip a soft cloth into
          the solution, wring out excess water and wipe the cork surface with
          gentle movements. Use a clean, damp cloth to remove any soap residue.
          Dry with a soft, dry cloth.
        </p>
        <p>
          <div className={styles.noahBold}>Deep Cleaning</div>
        </p>
        <p>
          Additional Care: Avoid exposure to water and immersing cork products
          in water, as this can cause damage and deformation. If the cork
          product gets wet, dry it quickly with a soft cloth.Protection against
          heat and direct sunlight: Keep cork products away from sources of
          excessive heat and direct sunlight to prevent drying out and
          discoloration.
        </p>
      </>
    ),
  },
  {
    question: "What care should I take with Cork Matters products?",
    answer: (
      <>
        <p>
          <div className={styles.noahBold}>Suitable Cleaning Products:</div> Use
          only mild cleaning products and avoid aggressive, abrasive or
          alcohol-based chemicals, which can damage the cork.
          <div className={styles.noahBold}>Regular Maintenance:</div> Carry out
          regular cleaning to prevent the build-up of dirt and stains. Keep cork
          products away from sources of excessive heat and direct sunlight to
          prevent discoloration.
          <div className={styles.noahBold}>Suitable Cleaning Products:</div>
          Use only mild cleaning products and avoid aggressive, abrasive or
          alcohol-based chemicals, which can damage the cork.
        </p>
        <p>
          <div className={styles.noahBold}>Regular Cleaning</div>
        </p>
        <p>
          Light Dust and Dirt: Use a soft, dry cloth or a soft-bristled brush to
          remove dust and light dirt from the surface.
        </p>
        <p>
          <div className={styles.noahBold}>Heavier Stains and Dirt:</div>
        </p>
        <p>
          Prepare a solution of warm water and mild soap. Dip a soft cloth into
          the solution, wring out excess water and wipe the cork surface with
          gentle movements. Use a clean, damp cloth to remove any soap residue.
          Dry with a soft, dry cloth.
        </p>
        <p>
          <div className={styles.noahBold}>Deep Cleaning</div>
        </p>
        <p>
          Additional Care: Avoid exposure to water and immersing cork products
          in water, as this can cause damage and deformation. If the cork
          product gets wet, dry it quickly with a soft cloth.Protection against
          heat and direct sunlight: Keep cork products away from sources of
          excessive heat and direct sunlight to prevent drying out and
          discoloration.
        </p>
      </>
    ),
  },
  {
    question: "The origin of Cork Matters' cork production?",
    answer: (
      <>
        <p>
          Cork Matters is a company that specializes in producing a variety of
          cork products. Understanding the origin of their cork is essential for
          appreciating the sustainability and quality of their offerings.
        </p>
        <p>
          <div className={styles.noahBold}>Manual Stripping:</div> Cork
          harvesting is done by skilled workers who carefully strip the bark
          from the trees using specialized tools. This process does not harm the
          tree, allowing it to regenerate its bark.
        </p>
        <p>
          <div className={styles.noahBold}>Virgin Cork:</div> The first harvest,
          known as virgin cork, typically occurs when the tree is about 25 years
          old. This cork is of lower quality and is usually used for products
          that do not require high-grade cork.
        </p>
        <p>
          <div className={styles.noahBold}>Boiling and Cleaning:</div> Harvested
          cork is boiled and cleaned to remove impurities and improve its
          elasticity.
        </p>
        <p>
          <div className={styles.noahBold}>Cutting and Shaping:</div> The cork
          is then cut and shaped into various products, depending on the
          intended use.
        </p>
        <p>
          Cork Matters produces a wide range of products, including cork
          stoppers, flooring, wall coverings, fashion accessories, and household
          items.
        </p>
        <p>
          <div className={styles.noahBold}>Customization:</div> They also offer
          customized cork products tailored to specific customer needs.
        </p>
        <p>
          All Cork Matters products are made from Portuguese cork, and are
          processed and industrialized in factories in the north of Portugal.
        </p>
        <p>
          <div className={styles.noahBold}>Cork Matters made in Portugal.</div>
        </p>
      </>
    ),
  },
  {
    question: "What limitations do cork products have?",
    answer: (
      <>
        <p>
          <div className={styles.noahBold}>Durability:</div>
        </p>
        <p>
          <div className={styles.noahBold}>Wear and Tear:</div> Although cork is
          durable, it is softer than many other materials and can be prone to
          dents, scratches, and abrasions, especially in high-traffic areas.
        </p>
        <p>
          <div className={styles.noahBold}>Moisture Sensitivity:</div> Prolonged
          exposure to water can damage cork, causing it to swell, warp, or break
          down over time. This makes it less suitable for areas with high
          humidity or frequent exposure to liquids.
        </p>
        <p>
          <div className={styles.noahBold}>Maintenance:</div>
        </p>
        <p>
          <div className={styles.noahBold}>Regular Care Required:</div> Cork
          requires regular maintenance, including cleaning and occasional
          sealing, to maintain its appearance and functionality. Without proper
          care, cork can degrade faster than other materials.
        </p>
        <p>
          <div className={styles.noahBold}>Staining:</div>
        </p>
        <p>
          <div className={styles.noahBold}>Susceptibility to Stains:</div> Cork
          can absorb liquids and stains if not properly sealed, making it more
          challenging to keep clean in environments prone to spills, such as
          kitchens and dining areas.
        </p>
        <p>
          <div className={styles.noahBold}>Temperature Sensitivity:</div>
        </p>
        <p>
          <div className={styles.noahBold}>Thermal Conductivity:</div> Cork is a
          good insulator, but it can also be sensitive to extreme temperatures.
          Exposure to high heat can cause cork to dry out and become brittle,
          while freezing temperatures can make it more prone to cracking.
        </p>
        <p>
          <div className={styles.noahBold}>Limited Availability:</div>
        </p>
        <p>
          <div className={styles.noahBold}>Geographical Constraints:</div> Cork
          is primarily harvested in the Mediterranean region, particularly in
          Portugal and Spain. This geographical limitation can affect the supply
          chain and availability of cork products globally.
        </p>
      </>
    ),
  },
];

function FAQ() {
  const [activeIndex, setActiveIndex] = useState(null);
  const faqRef = useRef(null);

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  useGSAP(() => {
    gsap.from(faqRef.current.children, {
      y: 100, // move the items up
      opacity: 0, // start with 0 opacity
      stagger: 0.25, // stagger the appearance of each item
      ease: "power2.out",
      duration: 1,
      delay: 0.4,
      scrollTrigger: {
        trigger: faqRef.current,
        start: "top 30%", // start when the section enters the viewport
        toggleActions: "play none none none", // only play the animation once
      },
    });
  });

  return (
    <div className={styles.faqContainer}>
      <div className={styles.grid} ref={faqRef}>
        <p className={styles.faqTitle}>Frequently Asked Questions</p>
        {questionsAndAnswers.map((qa, index) => (
          <div key={index} className={styles.faqItem}>
            <div
              className={styles.faqQuestion}
              onClick={() => toggleFAQ(index)}
            >
              {qa.question}
            </div>
            <div
              className={`${styles.faqAnswer} ${
                activeIndex === index ? styles.active : ""
              }`}
            >
              {qa.answer}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default FAQ;
